/**
 * The route table (SPEC §9.1), separate from `App` so tests can mount it in a
 * memory router without also standing up a browser history.
 */

import type { RouteObject } from 'react-router'
import { Navigate } from 'react-router'
import { createElement } from 'react'

import { AdminAudit } from './admin/AdminAudit'
import { AdminCache } from './admin/AdminCache'
import { AdminDepartments } from './admin/AdminDepartments'
import { AdminLayout } from './admin/AdminLayout'
import { AdminReports } from './admin/AdminReports'
import { AdminRoles } from './admin/AdminRoles'
import { AdminUserDetail } from './admin/AdminUserDetail'
import { AdminUsers } from './admin/AdminUsers'
import { Department } from './Department'
import { Departments } from './Departments'
import { NoAccess } from './NoAccess'
import { Report } from './Report'
import { Root } from './Root'

export const routes: RouteObject[] = [
  {
    path: '/',
    Component: Root,
    children: [
      { index: true, Component: Departments },
      { path: 'd/:department', Component: Department },
      { path: 'd/:department/r/:slug', Component: Report },
      { path: 'no-access', Component: NoAccess },
      {
        path: 'admin',
        Component: AdminLayout,
        children: [
          // §9.1: `/admin` redirects to the user list.
          { index: true, element: createElement(Navigate, { to: '/admin/users', replace: true }) },
          { path: 'users', Component: AdminUsers },
          { path: 'users/:id', Component: AdminUserDetail },
          { path: 'roles', Component: AdminRoles },
          { path: 'departments', Component: AdminDepartments },
          { path: 'reports', Component: AdminReports },
          { path: 'audit', Component: AdminAudit },
          { path: 'cache', Component: AdminCache },
        ],
      },
    ],
  },
]
